exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".times-combo-contanier {\n  padding: 20px;\n  text-align: left; }\n  .times-combo-contanier .times-combo-title {\n    font-size: 24px;\n    font-weight: 550;\n    margin-bottom: 20px; }\n\n.ant-cascader.custom-cascader .ant-select-selector {\n  padding: 3px 4px;\n  border: 1px solid #bfcbd9 !important;\n  border-radius: 4px !important; }\n\n.table-colum {\n  display: flex; }\n  .table-colum p {\n    margin-left: 10px; }\n\n.add-times-main {\n  padding: 20px; }\n", ""]);

// exports
